import { ReactElement, isValidElement } from "react";

import { DropdownAnchorProps, DropdownAnchor } from "./anchor";
import { DropdownPopOverProps, DropdownPopOver } from "./pop-over/pop-over";

export const isDropdownAnchorComp = (
  node: any
): node is ReactElement<DropdownAnchorProps, typeof DropdownAnchor> =>
  isValidElement(node) && node.type === DropdownAnchor;

export const isDropdownPopOverComp = (
  node: any
): node is ReactElement<DropdownPopOverProps, typeof DropdownPopOver> =>
  isValidElement(node) && node.type === DropdownPopOver;
